/* ── Currency Configuration ────────────────────────────────────────────────────
   Single source of truth for currency across the entire project.
   Currency is locked to INR (₹) as per business requirement.
   Do NOT read from localStorage — INR is always returned.
──────────────────────────────────────────────────────────────────────────────── */

export const SUPPORTED_CURRENCIES = [
  { code: 'INR', symbol: '₹', locale: 'en-IN',  label: 'Indian Rupee (₹)'    },
  { code: 'USD', symbol: '$', locale: 'en-US',  label: 'US Dollar ($)'        },
  { code: 'EUR', symbol: '€', locale: 'de-DE',  label: 'Euro (€)'             },
  { code: 'GBP', symbol: '£', locale: 'en-GB',  label: 'British Pound (£)'    },
  { code: 'AED', symbol: 'د.إ', locale: 'ar-AE', label: 'UAE Dirham (د.إ)'   },
  { code: 'SGD', symbol: 'S$', locale: 'en-SG', label: 'Singapore Dollar (S$)'},
];

// Locked to INR — always returns INR regardless of any stored preference
const INR = SUPPORTED_CURRENCIES[0];

export const getCurrencyConfig = () => INR;

// No-op: currency switching is disabled; always returns INR
export const setCurrencyConfig = () => INR;
